export class ProtocolFindBySensorDataWrapper {
    position: number;
    serialCode: string;
    userCode: string;
    email: string;
    lastTimeUsedDate: number;
    firstTimeUsedDate: number;

    constructor(position: number,
                serialCode: string,
                userCode: string,
                email: string,
                lastTimeUsedDate: number,
                firstTimeUsedDate: number) {
        this.position = position;
        this.serialCode = serialCode;
        this.userCode = userCode;
        this.email = email;
        this.lastTimeUsedDate = lastTimeUsedDate;
        this.firstTimeUsedDate = firstTimeUsedDate;
    }
}
